import { animation, animate, style } from '@angular/animations';

export const flyDownUpAnimation = animation([
  style({ transform: 'translateY(100%)', opacity: 0 }),
  animate('300ms cubic-bezier(0.35, 0, 0.25, 1)'),
]);
